<template>
  <div>
    <v-toolbar flat color="white">
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog persistent v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-autocomplete
                    v-model="editedItem.serviceId"
                    :items="availableServices"
                    :item-text="item => `(${item.code}) ${item.title}`"
                    item-value="id"
                    solo
                    label="Service"
                  >
                  </v-autocomplete>
                  <v-autocomplete
                    v-model="editedItem.stainId"
                    :items="availableStains"
                    item-value="id"
                    label="Stains"
                    item-text="title"
                    solo
                  >
                  </v-autocomplete>
                  <v-checkbox
                    v-model="editedItem.isFromIncomingBlock"
                    :label="`Slide created from incoming histoblock`"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="availableSlideServiceRiched"
      class="elevation-1"
      :search="search"
      :rows-per-page-items="[15, 30, 40]"
    >
      <template v-slot:items="props">
        <td>{{ props.item.stainName }}</td>
        <td>{{ props.item.serviceName }}</td>
        <td>{{ props.item.isFromIncomingBlockName }}</td>
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">
            edit
          </v-icon>
          <v-icon small @click="deleteItem(props.item)">
            delete
          </v-icon>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import _ from 'lodash'

export default {
  data: () => ({
    dialog: false,
    search: "",
    headers: [
      {
        text: "Stains",
        align: "left",
        sortable: false,
        value: "stainName"
      },
      {
        text: "Service",
        align: "left",
        sortable: false,
        value: "serviceName"
      },
      {
        text: "Slide created from incoming histoblock",
        align: "left",
        sortable: false,
        value: "isFromIncomingBlockName"
      },
      {
        text: "Action",
        align: "center",
        sortable: false
      }
    ],
    editedIndex: -1,
    editedItem: {
      id: null,
      stainId: "",
      serviceId: "",
      isFromIncomingBlock: false,
    },
    defaultItem: {
      id: null,
      stainId: "",
      serviceId: "",
      isFromIncomingBlock: false,
    }
  }),

  computed: {
    ...mapState({
      availableSlideService: "availableSlideService",
      availableServices: "availableServices",
      availableStains: "availableStains"
    }),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    availableSlideServiceRiched () {
      let items = []

      for (let slideService of this.availableSlideService){
        items.push({
          ...slideService,
          stainName: this.getStainName(slideService.stainId),
          serviceName: this.getServiceName(slideService.serviceId),
          isFromIncomingBlockName: slideService.isFromIncomingBlock ? "Yes" : "No"
        })
      }

      return items
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  methods: {
    ...mapActions({
      slideServiceCreate: "slideServiceCreate",
      slideServiceUpdate: "slideServiceUpdate",
      slideServiceDelete: "slideServiceDelete"
    }),

    getStainName(id){
      let item = _.find(this.availableStains, item => {
        return item.id === id
      });

      if(!item){
        return "Stain not found"
      }

      return `${item.title}`
    },

    getServiceName(id){
      let item = _.find(this.availableServices, item => {
        return item.id === id
      });

      if(!item){
        return "Service not found"
      }

      return `(${item.code}) ${item.title}`
    },

    editItem(item) {
      this.editedIndex = _.findIndex(this.availableSlideService, i => {
        return i.id === item.id
      });

      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      confirm("Are you sure you want to delete this item?") &&
        this.slideServiceDelete(item);
    },

    close() {
      this.dialog = false;

      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        this.slideServiceUpdate(this.editedItem);
      } else {
        this.slideServiceCreate(this.editedItem);
      }
      this.close();
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/References/SlideService.vue